<template >
<v-card class="card">
   <v-toolbar class="toolbar"
      color="primary"
      dark
      :loading="loading"
      id="collection-detail-toolbar"
      prominent
      extended
      extension-height="10"
    >



<v-list-item>

    <v-tooltip bottom
    nudge-top="20"
      nudge-right="18">
        <template v-slot:activator="{ on, attrs }">
            <v-btn

                icon
                :disabled="collection.download_url === null"
                :href="collection.download_url"
                x-large
                v-bind="attrs"
                v-on="on"
            >
                <v-icon>mdi-folder-download</v-icon>

            </v-btn>
        </template>
        <span>Download</span>
    </v-tooltip>

    <v-tooltip bottom
    nudge-top="20"
      nudge-right="18">

        <template v-slot:activator="{ on, attrs }">

            <v-btn
             v-bind="attrs"
            v-on="on"
            icon
            @click.stop="startFileGeneration(collection)"

            >
                <v-icon >
                mdi-database-export
                </v-icon>

            </v-btn>

        </template>
        <span>{{buttonLabel(collection)}}</span>
    </v-tooltip>

    <v-tooltip bottom
    nudge-top="20"
      nudge-right="18">

        <template v-slot:activator="{ on, attrs }">
            <!-- wrapping the button in div lets you display the tooltip even when the button is disabled -->
            <div v-on="on">
             <v-btn
             icon
             @click="showInput(collection)"
            id="collection-detail-rename"
            v-bind="attrs"
            v-on="on"
            :disabled="pencilIsDisabled"
            >
                <v-icon>mdi-pencil</v-icon>

            </v-btn>

            </div>
        </template>
        <span>{{showMessage? `Only owners can edit`: 'Edit'}}</span>
    </v-tooltip>

    <DeleteButton
         route="collection"
        :id="collection.id"
        color="undefined"
        name="collection"
        :size="size"
        :disabled="deleteIsDisabled"
    />



 </v-list-item>
    <v-hover v-slot="{ hover }">
  <v-toolbar-title  :class ="cursorStyle(collection, hover)"
  v-if="form!==collection.id"
   :title="myCollections.find(col=>col.id === collection.id)? 'Double-click to edit': ''"
    @dblclick="showInput(collection)"
  >
    {{collection.name}}
  </v-toolbar-title>
  </v-hover>

   <v-toolbar-title v-if="form===collection.id" :key="form">
            <EditingForm :item="collection" :update="update" color="white" @hideForm="form=''" route="collections"/>

   </v-toolbar-title>
  <p v-if="form !==collection.id">
    {{`Created: ${formatDate(new Date(collection.created_at))} |`}}
     {{ collection.download_generated_at ? `Generated: ${formatDate(new Date(collection.download_generated_at))}`
         : collection.download_generation_status == 'Generating' ? `Generation in progress ${collection.download_generation_started_at ? ' since ' + formatDate(new Date(collection.download_generation_started_at)) : ''}`
                  : 'Download not generated yet' }}
 </p>
 </v-toolbar>

<v-card-text class="scroll">

<v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search by CUSIP"
        class="search-field"
      ></v-text-field>

  <v-data-table
    :headers="headers"
    :items="collectionItems"
    :search="search"

  >
    <template #item.cusip="{ value }">
            <a :href="`/securities/${value}`" v-text="value">

            </a>
        </template>
  </v-data-table>
</v-card-text>

</v-card>
</template>

<script>
import {mapState} from 'vuex'
import { formatDate } from '@/utils/format'
import {startFileGeneration, update} from '@/utils/collections'
import DeleteButton from '@/components/DeleteButton.vue'
import EditingForm from '@/components/EditingForm.vue'
export default {
    name: 'CollectionDetail',
    components: {DeleteButton, EditingForm},
    data(){
       return {
        search: '',
        size: {small: false},
        headers: [
            {text: "CUSIP", value: "cusip"},
            {text:"Weight", value: "weight", filterable:false},
            {text:"Asset subclass", value:"security_type", filterable:false}
        ],
        dictionary: {
            cmbs: 'CMBS',
            na: 'NonAgency',
            pt: 'Agency RMBS',
            crt: 'Agency CRT'
        },
        form: ''
       }
    },

    computed: {
        inMyCollections(){
            return this.myCollections.find(collection=>collection.id===this.collection.id);
        },
        inSharedCollections(){
            //intentionally defining this in terms of this.myCollections, not this.sharedCollections, because this.sharedCollections might be empty if we're in the myCollections tab

            //note that myCollections will never be empty (except while actively fetching collections from the database) because as things are implemented, you can only get to the sharedCollections tab by first navigating to myCollections
            return this.inMyCollections === undefined

        },
        showMessage(){
           return this.inSharedCollections
        },
        collectionItems(){
                return this.cleanup(this.$store.state.collectionItems)
        },
        pencilIsDisabled(){
            let isForm = this.form===this.collection.id
            let inMyCollections = this.myCollections.find(x=>x.id===this.collection.id)
            return !inMyCollections || isForm
        },
        deleteIsDisabled(){
             let inMyCollections = this.myCollections.find(x=>x.id===this.collection.id)
             return !inMyCollections
        },
        ...mapState({
            collectionId: 'collectionId',
            collection: state=> {
                return {...state.collection,
                formId: `rh-form-${state.collection.id}`,
                titleId: `rh-title-${state.collection.id}`
                }
            } ,
            sharedCollections: 'sharedCollections',
            myCollections: 'myCollections',
            loading: 'loading'
        })
    },
    methods: {
        cursorStyle(item, hover){
            return hover && this.myCollections.find(col=>col.id===item.id)?'text-cursor': 'default-cursor'
        },
        update(item){
            //go back to displaying collection title instead of input form:
            this.form = '';
            return update(item)
        },
        cleanup(arr){
            return arr.map(item  => {
               return  {cusip: item.cusip,
            weight: item.amount,
            security_type: this.dictionary[item.security_type]}
            })
        },
        removeForm(event){
            if(this.form){
                let toolbar = document.getElementsByClassName("toolbar")[0];
                if(!toolbar.contains(event.target)){
                this.form = ''
             }
            }
        },
        buttonLabel(item) {
            return item.download_generation_status == 'Generated' ? 'Re-generate' : 'Generate'
        },
        startFileGeneration(collection) {
            startFileGeneration(collection.id)
            .then(response => {
                this.$store.dispatch('updateState', ['colToGenerate', collection.id]);
                this.$store.dispatch('updateState', ['collectionListRefreshedAt', Date.now()])
            })
        },
       formatDate(date, localeOptions, hideTime = false) {
        return date === null? '': formatDate(date, null, false)
        },
        showInput(item){
         if(this.myCollections.find(col=>col.id===item.id)){
            let id = item.id
            //display rename form instead of text at selected item:
            this.form = id;
            //wait for input form to display, then mark input text as selected:
            this.$nextTick(()=>{
                let input = document.querySelector(`#rh-form-${id} input`);
                input.focus();
                input.select()})
            }
        },
    },
    mounted(){
         document.addEventListener('click',e=> this.removeForm(e))
        }
}

</script>



<style>
#collection-detail-toolbar .v-list-item{
    align-self:flex-end;

}
#collection-detail-toolbar .v-toolbar__content{
    flex-direction: column;
}

#collection-detail-toolbar .v-toolbar__title, #collection-detail-toolbar p{
    align-self:center;
}

/* #collection-detail-toolbar .v-toolbar__title{
    line-height:50px;
} */



#collection-detail-toolbar p{
    margin-bottom:0;
}
#collection-detail-toolbar .v-toolbar__title{
    /* margin-bottom:5px; */
    overflow: visible;
    padding:0;
    /* display:flex;
    flex-direction:column;
    flex-basis: 150px;
    flex:1; */
}

#collection-detail-toolbar .v-btn__content {
  flex-direction: column;
  /* flex:1; */
}


</style>


<style scoped>
.text-cursor{
    cursor: text
}
.search-field{
    width:45%;
    margin-left:15px;
}

.default-cursor{
    cursor: default
}
.scroll{
     overflow-y:scroll;
     max-height: 72vh;

}

@media only screen and (max-height:860px){
.scroll{
    max-height: 66vh;
}
}

@media only screen and (max-height:800px){
.scroll{
    max-height: 63vh;
}
}

@media only screen and (max-height:750px){
.scroll{
    max-height: 60vh;
}
}
/* .card{
     max-height:100vh;
} */
</style>
